import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../components/footer";
import { ToastContainer } from "react-toastify";

const FrontLayout = () => {
  return (
    <div>
      <Outlet />
      <Footer />
      <ToastContainer />
    </div>
  );
};

export default FrontLayout;
